import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'react-table';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { itineraryChangeRouteBasicInformationPropTypes } from '../proptypes/ItineraryChangeRoutePropTypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import EnumStatus from '../../../../common/EnumStatus';
import { ITINERARY_CHANGE_ROUTE_STATUS } from '../../../../../config/constants';
import {
  ITINERARY_FOR_COUNTER_PATH,
  ROUTE_PATH,
} from '../../../../../config/paths';
import DateCell from '../../../../common/cells/DateCell';

const ItineraryChangeRouteBasicInformationResource = ({
  id,
  user,
  comment,
  status,
  createDate,
  newRoute,
  oldRouteNames,
  itineraryChangeRouteDetailList,
}) => (
  <>
    <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>

    <ResourceProperty label="Usuario:">
      {user ? user.fullName : '-'}
    </ResourceProperty>

    <ResourceProperty label="Comentario:">{comment || '-'}</ResourceProperty>

    <ResourceProperty label="Estado:">
      <EnumStatus
        enumObject={ITINERARY_CHANGE_ROUTE_STATUS}
        enumValue={status}
      />
    </ResourceProperty>

    <ResourceProperty label="Fecha de Creación:">
      {createDate
        ? tzNormalizeDate({ date: createDate, format: DATE_TIME_FORMAT })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Ruta Anterior:">
      {oldRouteNames || '-'}
    </ResourceProperty>

    <ResourceProperty label="Nueva Ruta:">
      {newRoute ? newRoute.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Cantidad de Itinerarios:">
      {itineraryChangeRouteDetailList
        ? itineraryChangeRouteDetailList.length
        : 0}
    </ResourceProperty>

    <hr />

    {itineraryChangeRouteDetailList &&
    itineraryChangeRouteDetailList.length > 0 ? (
      <Table
        columns={[
          {
            Header: 'ID Itinerario',
            accessor: 'itineraryId',
            className: 'text-center',
            Cell: (row) =>
              row.value ? (
                <Link
                  to={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
                  target="_blank"
                >
                  {row.value}
                </Link>
              ) : (
                '-'
              ),
          },
          {
            Header: 'Fecha de Salida',
            accessor: 'itineraryDepartureTime',
            className: 'text-center',
            Cell: (row) => <DateCell value={row.value} />,
          },
          {
            Header: 'Ruta Anterior',
            accessor: (row) => ({
              id: row.oldRouteId,
              name: row.oldRoute ? row.oldRoute.name : null,
            }),
            id: 'oldRoute',
            className: 'text-center',
            Cell: (row) =>
              row.value && row.value.id ? (
                <Link to={`${ROUTE_PATH}/${row.value.id}`} target="_blank">
                  {row.value.name
                    ? `${row.value.id} - ${row.value.name}`
                    : row.value.id}
                </Link>
              ) : (
                '-'
              ),
          },
          {
            Header: 'Nueva Ruta',
            accessor: (row) => ({
              id: row.newRouteId,
              name: row.newRoute ? row.newRoute.name : null,
            }),
            id: 'newRoute',
            className: 'text-center',
            Cell: (row) =>
              row.value && row.value.id ? (
                <Link to={`${ROUTE_PATH}/${row.value.id}`} target="_blank">
                  {row.value.name
                    ? `${row.value.id} - ${row.value.name}`
                    : row.value.id}
                </Link>
              ) : (
                '-'
              ),
          },
          {
            Header: 'Tipo Servicio Anterior',
            accessor: (row) =>
              row.oldServiceType ? row.oldServiceType.name : null,
            id: 'oldServiceTypeName',
            className: 'text-center',
            Cell: (row) => row.value || '-',
          },
          {
            Header: 'Nueva Ruta',
            accessor: (row) =>
              row.newRouteId && row.newRoute
                ? {
                    id: row.newRouteId,
                    name: row.newRoute.name,
                  }
                : null,
            id: 'newRoute',
            className: 'text-center',
            Cell: (row) =>
              row.value ? (
                <Link to={`${ROUTE_PATH}/${row.value.id}`} target="_blank">
                  {`${row.value.id} - ${row.value.name}`}
                </Link>
              ) : (
                '-'
              ),
          },
          {
            Header: 'Nuevo Tipo Servicio ',
            accessor: (row) =>
              row.newServiceType ? row.newServiceType.name : null,
            id: 'newServiceTypeName',
            className: 'text-center',
            Cell: (row) => row.value || '-',
          },
          {
            Header: 'Estado',
            accessor: 'changeStatus',
            className: 'text-center',
            Cell: (row) => (
              <EnumStatus
                enumObject={ITINERARY_CHANGE_ROUTE_STATUS}
                enumValue={row.value}
              />
            ),
          },
          {
            Header: 'Conflicto',
            accessor: 'conflictLog',
            className: 'text-center',
            Cell: (row) => row.value || '-',
          },
        ]}
        data={itineraryChangeRouteDetailList}
        manual={false}
        defaultPageSize={itineraryChangeRouteDetailList.length}
        showPagination={itineraryChangeRouteDetailList.length > 10}
      />
    ) : (
      <div className="alert alert-info">Sin detalle de cambio de ruta</div>
    )}
  </>
);

ItineraryChangeRouteBasicInformationResource.propTypes =
  itineraryChangeRouteBasicInformationPropTypes;

export default ItineraryChangeRouteBasicInformationResource;
